import { DS } from "../../../theme-default";
import React from "react";
import { styles } from "../../menu/styles";
import styled from "styled-components";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import { SkyLightStateless } from "react-skylight";
import Header from "../../header";
import {
  CircularProgress,
  DatePicker,
  RaisedButton,
  TextField
} from "material-ui";
import { connect } from "react-redux";
import * as ErrorAction from "../../../redux/action/error-action";
import moment from "moment";
import * as validator from "../../../general/validators/validator";
import { Constants as Contants } from "../../../constants";
import request from "../../../config/axios-config";

const Body = styled.div`
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
`;

const TextFieldStyled = styled(TextField)`
  width: 300px;
`;

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-between;

  max-width: 768px;
`;

const SaveContainer = styled(HorizontalContainer)`
  justify-content: flex-end;
  align-items: center;
`;

const HeaderContainer = styled.div`
  display: flex;
`;

class ContractsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: true,
      saving: false,
      id: null,
      type: "",
      serviceName: "",
      contractNr: "",
      contractDate: null,
      contractObject: "",
      appliedProcedure: "",
      purchaseRequisitionNr: "",
      supplier: "",
      contractValue: "",
      financeSource: "Bugetul de stat",
      startDate: null,
      endDate: null,
      priceModifier: "",
      paymentValueWithVat: "",
      paymentDate: "",
      errors: {}
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (data) {
      this.setState({
        id: data.id,
        type: data.type,
        serviceName: data.serviceName,
        contractNr: data.contractNr,
        contractDate: new Date(data.contractDate),
        contractObject: data.contractObject,
        appliedProcedure: data.appliedProcedure,
        purchaseRequisitionNr: data.purchaseRequisitionNr,
        supplier: data.supplier,
        contractValue: data.contractValue,
        financeSource: data.financeSource,
        startDate: new Date(data.startDate),
        endDate: new Date(data.endDate),
        priceModifier: data.priceModifier,
        paymentValueWithVat: data.paymentValueWithVat,
        paymentDate: data.paymentDate
      });
    }
  }

  closeModal = shouldRefresh => {
    this.setState({
      modalIsOpen: false
    });
    this.props.hideError();
    this.props.onCancel(shouldRefresh);
  };

  onSave = () => {
    const data = { ...this.state };

    if (this.hasErrors(data)) {
      return;
    }

    this.setState({ saving: true });

    request({
      url: Contants.SERVER_ENDPOINT + "/contracts/",
      method: "POST",
      data: data
    })
      .then(response => {
        console.log("lucitest on save comp", response);
        this.closeModal(true);
        this.setState({
          saving: false
        });
      })
      .catch(err => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message === "ERROR_DUPLICATE_CONTRACT_NUMBER"
        ) {
          this.props.showError(
            "DUPLICAT: Deja exista un contract cu numarul " +
              this.state.contractNr
          );
        } else {
          this.props.showError("Salvarea a esuat! Va rog reincercati!");
        }

        this.setState({
          saving: false
        });
      });
  };

  hasErrors = data => {
    let found = false;
    let error = {};

    if (validator.isEmpty(data.type)) {
      found = true;
      error.type = "Lipseste tipul contractului";
    }

    if (validator.isEmpty(data.serviceName)) {
      found = true;
      error.serviceName = "Lipseste numele serviciului";
    }

    if (validator.isEmpty(data.contractNr)) {
      found = true;
      error.contractNr = "Lipseste numarul contractului";
    }

    if (data.contractDate === null) {
      found = true;
      error.contractDate = "Lipseste data contractului";
    }

    if (validator.isEmpty(data.contractObject)) {
      found = true;
      error.contractObject = "Lipseste obiectul contractului";
    }

    if (validator.isEmpty(data.appliedProcedure)) {
      found = true;
      error.appliedProcedure = "Lipseste procedura aplicata";
    }

    if (validator.isEmpty(data.purchaseRequisitionNr)) {
      found = true;
      error.purchaseRequisitionNr = "Lipseste numarul referatului";
    }

    if (validator.isEmpty(data.supplier)) {
      found = true;
      error.supplier = "Lipseste prestatorul";
    }

    if (validator.isEmpty(data.contractValue)) {
      found = true;
      error.contractValue = "Lipseste valoarea";
    }

    if (validator.isEmpty(data.financeSource)) {
      found = true;
      error.financeSource = "Lipseste sursa de finantare";
    }

    if (data.startDate === null) {
      found = true;
      error.startDate = "Lipseste data de inceput";
    }

    if (data.endDate === null) {
      found = true;
      error.endDate = "Lipseste data de finalizare";
    }

    if (validator.isEmpty(data.paymentDate)) {
      found = true;
      error.paymentDate = "Lipseste data platii";
    }

    this.setState({
      errors: error
    });

    if (!found) {
      return null;
    }
    return error;
  };

  render() {
    const {
      saving,
      type,
      serviceName,
      contractNr,
      contractDate,
      contractObject,
      appliedProcedure,
      purchaseRequisitionNr,
      supplier,
      contractValue,
      financeSource,
      startDate,
      endDate,
      priceModifier,
      paymentValueWithVat,
      paymentDate
    } = this.state;

    const { title } = this.props;
    return (
      <div>
        <RedirectIfNotLogged />
        <SkyLightStateless
          isVisible={true}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={() => this.closeModal(false)}
          onOverlayClicked={() => this.closeModal(false)}
          title={
            <HeaderContainer>
              <Header title={title || "Adauga contract"} />
            </HeaderContainer>
          }
        >
          <Body>
            <HorizontalContainer>
              <VerticalContainer>
                <TextFieldStyled
                  floatingLabelText="Tip Contract"
                  type={"text"}
                  value={type}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      type: e.target.value
                    });
                  }}
                  errorText={this.state.errors.type}
                />

                <TextFieldStyled
                  floatingLabelText="Denumire serviciu"
                  type={"text"}
                  value={serviceName}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      serviceName: e.target.value
                    });
                  }}
                  errorText={this.state.errors.serviceName}
                />

                <TextFieldStyled
                  floatingLabelText="Nr. Contract"
                  type={"text"}
                  value={contractNr}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      contractNr: e.target.value
                    });
                  }}
                  errorText={this.state.errors.contractNr}
                />

                <DatePicker
                  inputStyle={{ color: DS.ink }}
                  onDismiss={() => this.setState({ contractDate: null })}
                  floatingLabelText="Data Contract"
                  value={contractDate}
                  onChange={(event, date) => {
                    this.setState({ contractDate: date });
                  }}
                  formatDate={date => moment(date).format("DD-MM-YYYY")}
                  errorText={this.state.errors.contractDate}
                />

                <TextFieldStyled
                  floatingLabelText="Obiectul Contractului"
                  type={"text"}
                  value={contractObject}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      contractObject: e.target.value
                    });
                  }}
                  errorText={this.state.errors.contractObject}
                />

                <TextFieldStyled
                  floatingLabelText="Procedura Aplicata"
                  type={"text"}
                  value={appliedProcedure}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      appliedProcedure: e.target.value
                    });
                  }}
                  errorText={this.state.errors.appliedProcedure}
                />

                <TextFieldStyled
                  floatingLabelText="Nr. Referat"
                  type={"text"}
                  value={purchaseRequisitionNr}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      purchaseRequisitionNr: e.target.value
                    });
                  }}
                  errorText={this.state.errors.purchaseRequisitionNr}
                />

                <TextFieldStyled
                  floatingLabelText="Furnizor/Prestator/Executant"
                  type={"text"}
                  value={supplier}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      supplier: e.target.value
                    });
                  }}
                  errorText={this.state.errors.supplier}
                />
              </VerticalContainer>

              <VerticalContainer style={{ marginLeft: 24 }}>
                <TextFieldStyled
                  floatingLabelText="Valoare prevazuta in contract"
                  type={"text"}
                  value={contractValue}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      contractValue: e.target.value
                    });
                  }}
                  errorText={this.state.errors.contractValue}
                />

                <TextFieldStyled
                  floatingLabelText="Sursa finantarii"
                  type={"text"}
                  value={financeSource}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      financeSource: e.target.value
                    });
                  }}
                  errorText={this.state.errors.financeSource}
                />

                <DatePicker
                  inputStyle={{ color: DS.ink }}
                  onDismiss={() => this.setState({ startDate: null })}
                  floatingLabelText="Data de inceput"
                  value={startDate}
                  onChange={(event, date) => {
                    this.setState({ startDate: date });
                  }}
                  formatDate={date => moment(date).format("DD-MM-YYYY")}
                  errorText={this.state.errors.startDate}
                />

                <DatePicker
                  inputStyle={{ color: DS.ink }}
                  onDismiss={() => this.setState({ endDate: null })}
                  floatingLabelText="Data de finalizare din contract"
                  value={endDate}
                  onChange={(event, date) => {
                    this.setState({ endDate: date });
                  }}
                  formatDate={date => moment(date).format("DD-MM-YYYY")}
                  errorText={this.state.errors.endDate}
                />

                <TextFieldStyled
                  floatingLabelText="Modificarea pretului prin act ad..."
                  type={"text"}
                  value={priceModifier}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      priceModifier: e.target.value
                    });
                  }}
                  errorText={this.state.errors.priceModifier}
                />
                <TextFieldStyled
                  floatingLabelText="Valoarea platita(cu TVA)"
                  type={"text"}
                  value={paymentValueWithVat}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      paymentValueWithVat: e.target.value
                    });
                  }}
                  errorText={this.state.errors.paymentValueWithVat}
                />

                <TextFieldStyled
                  floatingLabelText="Data efectuarii platii"
                  type={"text"}
                  value={paymentDate}
                  rowsMax={2}
                  onChange={e => {
                    this.setState({
                      paymentDate: e.target.value
                    });
                  }}
                  errorText={this.state.errors.paymentDate}
                />
              </VerticalContainer>
            </HorizontalContainer>

            <SaveContainer>
              <RaisedButton
                disabled={saving}
                style={{ marginTop: "20px" }}
                primary
                label={"Salveaza"}
                onClick={this.onSave}
              />

              {saving && <CircularProgress style={{ marginLeft: 24 }} />}
            </SaveContainer>
          </Body>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractsDialog);
